import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { LogoMark } from './Logo';
import { LEGAL } from '../content/legal';

export default function CorpFooter() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
    <footer className="corp-footer">
      <div className="container">
        <div className="cols">
          <div className="col brand-col">
            <span className="brand" style={{ fontSize: 16 }}>
              <LogoMark size={18} /> {t('brand')}
            </span>
            <p>{t('footer.tagline')}</p>
          </div>

          <div className="col">
            <h4>{t('footer.product')}</h4>
            <a href="/#features">{t('nav.features')}</a>
            <a href="/#how">{t('nav.how')}</a>
            <a href="/#pricing">{t('nav.pricing')}</a>
            <a href="/#faq">{t('footer.faq')}</a>
          </div>

          <div className="col">
            <h4>{t('footer.company')}</h4>
            <a href="/#neden">{t('landing.why_eyebrow')}</a>
            <a href="/#detect">{t('landing.detect_eyebrow')}</a>
            <a href={`mailto:${t('footer.email')}`}>{t('footer.contact')}</a>
          </div>

          <div className="col">
            <h4>{t('footer.legal')}</h4>
            <Link to="/gizlilik-politikasi">{LEGAL['gizlilik-politikasi'].title}</Link>
            <Link to="/kullanim-kosullari">{LEGAL['kullanim-kosullari'].title}</Link>
            <Link to="/kvkk">{LEGAL.kvkk.title}</Link>
          </div>
        </div>

        <div className="bottom">
          <span>© {year} {t('brand')} · VokerStudio · {t('landing.footer_rights')}</span>
          <span>{t('footer.made')}</span>
        </div>
      </div>
    </footer>
  );
}
